<template>
  <div id="app">
    <img src="./assets/logo.png">
    <router-view/>
    <div class="copyright">
      Copyright ©{{ year }} ebus.club 版权所有
      <a href="https://beian.miit.gov.cn/" target="_blank"> 粤ICP备18047374号-1</a>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

console.log(moment().format('YYYY'))

export default {
  name: "App",
  data: () => {
    return {
      year: moment().format('YYYY')
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.copyright {
  /*设置copy right的位置*/
  width: 100%;
  position: fixed;
  bottom: 0;
  text-align: center;
}
.copyright a {
  /*设置copy right的a标签样式*/
  color: #324057;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue